import { render, staticRenderFns } from "./RecuperarPass.vue?vue&type=template&id=07b03081&"
import script from "./RecuperarPass.vue?vue&type=script&lang=js&"
export * from "./RecuperarPass.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports